export const Urls = {
    BaseURL: 'cdn-base-url',

    // Page ids
    page_equipmentHouse: '2191',

    // Form ids
    form_equipmentHouse: '996',
    
}